import {CMDBPage} from './CMDB.jsx';
export default CMDBPage;
